import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/components/features/auth/LoginPage';
import { CreateAccountPage } from '@/components/features/auth/CreateAccountPage';
import { ForgotUsernamePage } from '@/components/features/auth/ForgotUsernamePage';
import { ForgotPasswordPage } from '@/components/features/auth/ForgotPasswordPage';
import { TermsAndConditionsPage } from '@/components/features/auth/TermsAndConditionsPage';
import { AppLayout } from '@/components/common/Layout/AppLayout';
import { DeviceListPage } from '@/components/features/devices/DeviceListPage';
import { FleetMapPage } from '@/components/features/fleet/FleetMapPage';
import { TrackingMapPage } from '@/components/features/tracking/TrackingMapPage';
import { SecurityStatusPanel } from '@/components/features/security/SecurityStatusPanel';
import { ApplicationsPage } from '@/components/features/applications/ApplicationsPage';
import { DeviceGeofencePage } from '@/components/features/applications/geofence/DeviceGeofencePage';
import { GlobalGeofencesPage } from '@/components/features/applications/geofence/GlobalGeofencesPage';
import { IntrusionZonesPanel } from '@/components/features/applications/intrusion/IntrusionZonesPanel';
import { SmokeCoZonesPanel } from '@/components/features/applications/smoke-co/SmokeCoZonesPanel';
import { TemperatureZonesPanel } from '@/components/features/applications/temperature/TemperatureZonesPanel';
import { MiscSirenZonesPanel } from '@/components/features/applications/misc-siren/MiscSirenZonesPanel';
import { MiscZonesPanel } from '@/components/features/applications/misc/MiscZonesPanel';
import { FloatSwitchPanel } from '@/components/features/applications/float-switch/FloatSwitchPanel';
import { SwitchesPanel } from '@/components/features/applications/switches/SwitchesPanel';
import { DCBanksPanel } from '@/components/features/applications/dc-banks/DCBanksPanel';
import { ACShorePanel } from '@/components/features/applications/ac-power/ACShorePanel';
import { ConfigurationPage } from '@/components/features/configuration/ConfigurationPage';
import { SensorsPage } from '@/components/features/sensors/SensorsPage';
import { ContactListPage } from '@/components/features/contacts/ContactListPage';
import { EventLogPage } from '@/components/features/logs/EventLogPage';
import { DeviceInfoPage } from '@/components/features/device-info/DeviceInfoPage';
import { CommunicationsPage } from '@/components/features/communications/CommunicationsPage';
import { AccountSettingsPage } from '@/components/features/account/AccountSettingsPage';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/create-account" element={<CreateAccountPage />} />
      <Route path="/forgot-username" element={<ForgotUsernamePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      {/* Semi-public: requires auth but not terms acceptance */}
      <Route path="/terms" element={<TermsAndConditionsPage />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/devices" element={<DeviceListPage />} />
        <Route path="/fleet" element={<FleetMapPage />} />
        <Route path="/account" element={<AccountSettingsPage />} />

        {/* Per-device routes */}
        <Route path="/device/:deviceUUID/tracking" element={<TrackingMapPage />} />
        <Route path="/device/:deviceUUID/security" element={<SecurityStatusPanel />} />
        <Route path="/device/:deviceUUID/applications" element={<ApplicationsPage />} />
        <Route path="/device/:deviceUUID/device-geofence" element={<DeviceGeofencePage />} />
        <Route path="/device/:deviceUUID/global-geofences" element={<GlobalGeofencesPage />} />
        <Route path="/device/:deviceUUID/intrusion" element={<IntrusionZonesPanel />} />
        <Route path="/device/:deviceUUID/smoke-co" element={<SmokeCoZonesPanel />} />
        <Route path="/device/:deviceUUID/temperature" element={<TemperatureZonesPanel />} />
        <Route path="/device/:deviceUUID/misc-siren" element={<MiscSirenZonesPanel />} />
        <Route path="/device/:deviceUUID/misc" element={<MiscZonesPanel />} />
        <Route path="/device/:deviceUUID/bilge" element={<FloatSwitchPanel />} />
        <Route path="/device/:deviceUUID/switches" element={<SwitchesPanel />} />
        <Route path="/device/:deviceUUID/dc-banks" element={<DCBanksPanel />} />
        <Route path="/device/:deviceUUID/ac-power" element={<ACShorePanel />} />
        <Route path="/device/:deviceUUID/configuration" element={<ConfigurationPage />} />
        <Route path="/device/:deviceUUID/sensors" element={<SensorsPage />} />
        <Route path="/device/:deviceUUID/contacts" element={<ContactListPage />} />
        <Route path="/device/:deviceUUID/logs" element={<EventLogPage />} />
        <Route path="/device/:deviceUUID/info" element={<DeviceInfoPage />} />
        <Route path="/device/:deviceUUID/communications" element={<CommunicationsPage />} />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/devices" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
